 /*global angular,ga,fbq,env,moment*/
'use strict';

angular.module('MrDWebApp')
  .controller('RootController', function ($scope, $rootScope, $window, $cookies, storage, settingsFactory, voteAreaFactory, $filter, $timeout, $state, $stateParams, $previousState, SEO, rootURL, $analytics, $http, pushnotes, $location) {

    var _rc = this;

    $previousState.memo('caller');

    _rc.ipay = true;

    _rc.state = $rootScope.state;

    _rc.bodyClass = 'html-root';

    _rc.themes = ['burger', 'pizza', 'chicken', 'sushi'];
    _rc.theme = _rc.themes[Math.floor(Math.random() * _rc.themes.length)];

    _rc.title_tag = 'Mr D Food - SA\'s favourite food delivery service!';
    _rc.description_tag = 'We\'re fresher, tastier and easier to use than ever. Get FREE delivery on your first app order';
    _rc.keywords_tag = 'food, restaurant, delivery, ordering, take-aways, app, application, online, south africa, mr delivery';

    _rc.baseURL = env.baseProtocol + $window.location.hostname;
    _rc.rootURL = rootURL;

    _rc.popup = false;
    _rc.findingOnMap = false;

    _rc.garbage = {};

    _rc.variables_template = {
      restaurant: {},
      restaurant_donation: window.config? window.config.default_restaurant_donation || 0 : 0,
      hasLocation: false,
      address: {},
      tip_percentage: 10
    };
    _rc.variables = angular.copy(_rc.variables_template);

    _rc.addresses = [];
    _rc.suggestions = [];

    _rc.access_template = {
      auth: false,
      loggedin: false,
      user: {}
    };
    _rc.access = angular.copy(_rc.access_template);

    _rc.findMeMapCreated = false;

    _rc.popups = {};
    if ($cookies.getObject('mrd-web-popups')) {
      _rc.popups = $cookies.getObject('mrd-web-popups');
    }

    _rc.shareSession = function(auth_hash, host) {
      //TODO: move to root so that it can be called from ProfileCtrl when the password/email is updated
      return new Promise(function(resolve,reject) {
        var timer = setTimeout(resolve, 3000);
        var portal = document.createElement('iframe');
        portal.style.display = 'none';
        //portal.sandbox = 'allow-same-origin allow-scripts';
        var onWinMsg = function(e) {
          if (e.origin !== host) {
            //console.log('Ignoring message from', e.origin);
            return;
          }
          if (!e.data) {
            //console.log('Empty message.');
            return;
          }
          if (e.data === 'ready') {
            console.log('Sending auth from', $window.origin, 'to', host);
            e.source.postMessage(auth_hash, host); //send auth to iframe
          } else if (e.data === 'done') {
            console.log('Session share complete.');
            document.body.removeChild(portal);
            clearTimeout(timer);
            resolve();
          } else {
            //console.warn('Unexpected message', e.data);
          }
        };
        $window.addEventListener('message', onWinMsg);
        portal.src = '/api/receiveauth';
        document.body.appendChild(portal);
      });
    };

    _rc.newDriverChatMessage = null;//{invoice_number:"DFD123451",message:"H!",createdAt:Date.now()};
    _rc.driverChatIsOpen = false;
    pushnotes.onMessageReceived = function(newDriverChatMessage) {
      //console.log('pushnotes.onMessageReceived',_rc.driverChatIsOpen);
      $rootScope.$broadcast('chat:message', newDriverChatMessage);
      if (!_rc.driverChatIsOpen) {
        _rc.newDriverChatMessage = newDriverChatMessage;
      }
    };
    _rc.openDriverChat = function(newDriverChatMessage){
      _rc.newDriverChatMessage = null;
      if (_rc.driverChatIsOpen) return;
      $state.go('tracking', { //TODO: don't change state if this is already the active state
        orderID: newDriverChatMessage.invoice_number.substring(3),//trim 'DFD'
        userID: newDriverChatMessage.userId,
        //map: '0',
        chat: '1'
      });
    };
    $rootScope.$on('chat:open', function (e, invoice_number) {
      if (_rc.newDriverChatMessage && _rc.newDriverChatMessage.invoice_number === invoice_number) {
        _rc.newDriverChatMessage = null;
      }
    });
    $rootScope.$on('chat:end', function (e, invoice_number) {
      if (_rc.newDriverChatMessage && _rc.newDriverChatMessage.invoice_number === invoice_number) {
        _rc.newDriverChatMessage = null;
      }
    });

    if (storage.get('mrd-web-access')) {
      _rc.access = {
        auth: storage.get('mrd-web-access').auth,
        loggedin: true,
        user: storage.get('mrd-web-access').user
      };
      if (_rc.access.user) window.Raven.setUserContext({
        id: _rc.access.user.id,
        email: _rc.access.user.profile? _rc.access.user.profile.email : null
      });
    }

    //#########################################################
    //  CART TEMPLATE
    //#########################################################

    _rc.cart_template = {
      'fresh': true,
      'status': 'new',
      'type': 'delivery',
      'customer': {
        'id': 0,
        'address': {
          'street_name': '',
          'suburb': '',
          'town': '',
          'province': '',
          'postal_code': '',
          'latitude': '',
          'longitude': '',
          'label': ''
        }
      },
      'items': [],
      'restaurant': {
        'id': 0,
        'menu_id': 0
      },
      'totals': {
        'delivery_fee': 0,
        'subtotal': 0,
        'processing_fee': 0,
      },
      'payment': {}
    };

    _rc.generateOrderSource = function() {
      return {
        application: 'CUSTOMER_APP',
        client_id: 'WEB_APP',
        client_version: $rootScope.application_version,
        client_build: $rootScope.build,
        platform_version: navigator.userAgent
      };
    };

    _rc.setOrderSource = function(order){
      order.order_source = _rc.generateOrderSource();
    };
    _rc.setOrderSource(_rc.cart_template);

    //#########################################################
    //  CART SETUP
    //#########################################################

    function clearStaleCart(){
      console.log('Cart is stale. Clearing...');
      _rc.clearCart();
      storage.remove('cart-last-update');
    }

    _rc.cart = angular.copy(_rc.cart_template);

    // Load from memory
    if (_rc.cart.fresh === true && storage.get('mrd-web-cart')) {
      _rc.cart = angular.copy(storage.get('mrd-web-cart'));
    }

    _rc.resetCartAge = function(){
      if (!window.config.cart_ttl_seconds) return;
      if (_rc.clearStaleCartTimer) {
        $timeout.cancel(_rc.clearStaleCartTimer);
      }
      if (!_rc.cart.items || !_rc.cart.items.length) {
        storage.remove('cart-last-update');
        return;
      }
      var ageLeftToLive = window.config.cart_ttl_seconds;
      storage.set('cart-last-update', Date.now() * 0.001); //seconds
      _rc.clearStaleCartTimer = $timeout(clearStaleCart, ageLeftToLive * 1000);
      console.log('Cart goes stale in', ageLeftToLive);
    };

    _rc.clearCartAge = function(){
      if (!window.config.cart_ttl_seconds) return;
      $timeout.cancel(_rc.clearStaleCartTimer);
      storage.remove('cart-last-update');
    };


    window.addEventListener('remote-config-loaded', function() {
      if (!window.config.cart_ttl_seconds) return;
      if (!_rc.cart.items || !_rc.cart.items.length) return;
      var now = Date.now() * 0.001; //seconds
      var cartlastUpdate = storage.get('cart-last-update');
      //console.log('cartlastUpdate:',cartlastUpdate);
      if (cartlastUpdate === null) cartlastUpdate = now;
      var cartAllowedAge = window.config.cart_ttl_seconds;
      var cartAge = now - cartlastUpdate;
      //console.log('cartAge:',cartAge);
      if (cartAge >= cartAllowedAge) {
        $rootScope.$apply(function(){ clearStaleCart(); });
        storage.remove('cart-last-update');
      } else {
        var ageLeftToLive = cartAllowedAge - cartAge;
        //console.log('Cart goes stale in', ageLeftToLive);
        _rc.clearStaleCartTimer = $timeout(clearStaleCart, ageLeftToLive * 1000);
      }
    });

    //#########################################################
    //  RESTORE LOCAL STORED DATA
    //#########################################################

    if (storage.get('mrd-web-addresses')) {
      _rc.addresses = angular.copy(storage.get('mrd-web-addresses'));
    }

    if (storage.get('mrd-web-variables')) {
      _rc.variables = angular.copy(storage.get('mrd-web-variables'));
    }

    if (storage.get('mrd-web-access')) {
      _rc.access = angular.copy(storage.get('mrd-web-access'));
      //console.log('found access in storage')
    } else {
      //console.log('no access in storage')
    }

    // Holiday Times
    var date1 = '2017-12-24';
    var date1Time = date1 + 'T14:00:00+02:00';
    var date2 = '2017-12-25';

    var date3 = '2017-12-31';
    var date3Time = date3 + 'T14:00:00+02:00';
    var date4 = '2018-01-01';

    if ((moment().isSame(date1, 'day') && moment().isAfter(date1Time)) || moment().isSame(date2, 'day')) {
      angular.element(document.getElementById('html')).addClass('html-global-banner html-global-banner-date-1');
    }
    if ((moment().isSame(date3, 'day') && moment().isAfter(date3Time)) || moment().isSame(date4, 'day')) {
      angular.element(document.getElementById('html')).addClass('html-global-banner html-global-banner-date-2');
    }


    _rc.changeTheme = function () {

      if (_rc.theme === 'burger') {
        _rc.theme = 'pizza';
      } else if (_rc.theme === 'pizza') {
        _rc.theme = 'chicken';
      } else if (_rc.theme === 'chicken') {
        _rc.theme = 'sushi';
      } else if (_rc.theme === 'sushi') {
        _rc.theme = 'burger';
      }
    };


    _rc.discounted_delivery = function (restaurant) {
      if (restaurant.active_promotion && typeof restaurant.active_promotion !== undefined && restaurant.active_promotion.delivery_fee >= 0 && (
          restaurant.delivery_option === 'delivery' ||
          restaurant.delivery_option === 'collect_and_delivery') &&
          restaurant.active_promotion.type !== 'CONDITIONAL_FREE_DELIVERY') {
        return true;
      } else {
        return false;
      }
    };

    _rc.clearCart = function () {
      _rc.cart = angular.copy(_rc.cart_template);
      // console.log('root.js, Clearing the cart...');
      // console.log(JSON.stringify(_rc.cart.total));
      _rc.cart.customer.address = $scope._rc.variables.address;
      delete _rc.cart.customer.address.street_number; // Remove street number for now...

      $rootScope.$broadcast('cart:modified', 'Cleared');
      storage.set('mrd-web-cart', _rc.cart);

      $scope._rc.variables.tip_percentage = 10; // reset tip bak to default 10
      storage.set('mrd-web-variables', $scope._rc.variables);
    };

    _rc.emptyCart = function () {

      _rc.cart.items = [];

      $rootScope.$broadcast('cart:modified', 'Emptied');
      storage.set('mrd-web-cart', _rc.cart);

      $scope._rc.variables.tip_percentage = 10; // reset tip bak to default 10
      storage.set('mrd-web-variables', $scope._rc.variables);
    };

    _rc.global_message_confirm = function () {

      if ($rootScope.global_message.name === 'confirm_cash_order') {
        $rootScope.$broadcast('global_message:hide');
      } else if ($rootScope.global_message.name === 'selected_from_other_restaurant') {
        _rc.clearCart();
        _rc.variables.restaurant = $rootScope.global_message.confirm_value_object;
        storage.set('mrd-web-variables', _rc.variables); // Save Restaurant
        $state.go($rootScope.global_message.confirm_value,
          {
            restaurantID: $rootScope.global_message.confirm_value_object.id,
            menuID: $rootScope.global_message.confirm_value_object.menu_id,
            restaurant: $rootScope.global_message.confirm_value_object
          }
        );
      } else if ($rootScope.global_message.name === 'payment_cancel') {
        _rc.cart.payment.type = 'credit'; // Reset to card..
        $state.go($rootScope.global_message.confirm_value, // checkout
          {
            orderID: $rootScope.global_message.confirm_value_object.id, // Cart
            userID: $scope._rc.access.user.id
          }
        );
      } else if ($rootScope.global_message.name === 'restaurants_load_failure') {
        $rootScope.$broadcast('loading:show');
        $state.go($rootScope.global_message.confirm_value, $rootScope.global_message.confirm_value_object);
      } else if ($rootScope.global_message.name === 'self_collect_warning') {
        $rootScope.global_message.confirm_value_object.initiateOrder();// ?? Crazy...
      } else if ($rootScope.global_message.name === 'send_invoice') {
        $rootScope.global_message.confirm_value_object.sendInvoice($rootScope.global_message.confirm_value);// ?? Crazy...
      } else if ($rootScope.global_message.confirm_action === 'redirect') {
        $state.go($rootScope.global_message.confirm_value);
      } else if ($rootScope.global_message.name === 'login_issue') {
        $scope._rc.softLogout();
        $state.go('login');
        //$rootScope.global_message.confirm_value_object.initiateOrder();// ?? Crazy...
      }
      $rootScope.$broadcast('global_message:hide');
    };

    _rc.global_message_deny = function () {
      $rootScope.$broadcast('global_message:hide');

      if ($rootScope.global_message.name === 'confirm_cash_order') {
        _rc.clearCart();
        $state.go('location', {
          lat: $scope._rc.variables.address.latitude,
          lng: $scope._rc.variables.address.longitude,
          street_name: $scope._rc.variables.address.street_name
        });
      } else if ($rootScope.global_message.name === 'selected_from_other_restaurant') {
        $state.go($rootScope.global_message.deny_value, {
          restaurantID: $rootScope.global_message.deny_value_object.id,
          menuID: $rootScope.global_message.deny_value_object.menu_id,
          restaurant: $rootScope.global_message.deny_value_object
        });
      } else if ($rootScope.global_message.name === 'select_other_restaurant' ||
        $rootScope.global_message.name === 'restaurant_offline' ||
        $rootScope.global_message.name === 'payment_cancel') {
        // New Order
        _rc.clearCart();
        $state.go($rootScope.global_message.deny_value, {
          lat: $rootScope.global_message.deny_value_object.address.latitude,
          lng: $rootScope.global_message.deny_value_object.address.longitude,
          street_name: $rootScope.global_message.deny_value_object.address.street_name
        });
      }
      $rootScope.$broadcast('global_message:hide');
    };

    _rc.global_message_custom_action = function(customAction) {
      $rootScope.$broadcast('global_message:hide');
      customAction.action.call(this);
    };

    _rc.restaurantTags = function (tags) {
      if (tags) {
        var arr = [];
        for (var i = 0; i < tags.length; i++) {
          arr.push(tags[i].name);
        }
        return arr.join(', ');
      }
      return 'No Tags';
    };

    _rc.remChatToken = function(){
      var pushToken = storage.get('driver-chat-signup-push-token');
      var uid = _rc.access.user&&_rc.access.user.id? _rc.access.user.id.toString() : null;
      if (pushToken) {
        return $http.post(window.env.apiURL + 'courier-chat/remove-token', {id:uid, push_token:pushToken}, {bypassErrorHandler:true})
        .then(function(){
          console.log('Chat unsubscribed.');
          storage.remove('driver-chat-signup-push-token');
          return true;
        })
        .catch(function(er){
          console.warn('Chat didn\'t unsubscribed.', er);
          return true;
        });
      }
      return Promise.resolve(true);
    };
    _rc.unregPushToken = function() {
      return pushnotes.unregister()
      .catch(function(){
        console.log('Could not remove FCM token.');
        return true;
      });
    };
    _rc.reset = function(){
      _rc.access = angular.copy(_rc.access_template);
      _rc.cart = angular.copy(_rc.cart_template);
      _rc.variables = angular.copy(_rc.variables_template);
      storage.set('mrd-web-access', _rc.access);
      storage.set('mrd-web-cart', _rc.cart);
      storage.set('mrd-web-variables', _rc.variables);
      window.Raven.setUserContext();
      delete $http.defaults.headers.common.Authorization;
    };
    _rc.goHomeAfterLogout = function(){
      if (window.env.domainSplit) {
        window.clearAuthOnSEOHost()
        .then(function(){
          window.location.href = '/';
        })
        .catch(function(){
          window.location.href = '/';
        });
      } else {
        $state.go('home');
      }
    };
    _rc.logout = function () {

      //driver chat unsubscribe Push Token
      _rc.remChatToken()
      .then(function(){
        return _rc.unregPushToken();
      })
      .then(function(){
        _rc.reset();
        _rc.goHomeAfterLogout();
      });

      /*  Firebase Push Unsubscribe */
      /* $rootScope.unSubscribeTokenToTopic($rootScope.firebaseUserToken, 'user_' + _rc.access.user.id + '_silent'); */

    };
    _rc.softLogout = function () {
      _rc.access = angular.copy(_rc.access_template);
      storage.set('mrd-web-access', _rc.access);
      window.Raven.setUserContext();
    };

    _rc.closeLogin = function () {

      if ($previousState.get('caller').state === null ||
        $state.current.name === 'login' ||
        $state.current.name === 'register' ||
        $state.current.name === 'forgot' ||
        $state.current.name === 'reset') {
          if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
      } else {
        $previousState.go('caller');
      }
      $previousState.memo('caller');
    };

    _rc.closeRegister = function () {

      if ($previousState.get('caller').state === null ||
        $previousState.get('caller').state.name === 'reset' ||
        $previousState.get('caller').state.name === 'forgot' ||
        $previousState.get('caller').state.name === 'login') {
          if (window.env.domainSplit) window.location.href = '/'; else $state.go('home');
      } else {
        $previousState.go('caller');
      }

    };

    _rc.newOrder = function () { // Hard Reset
      _rc.autocompleteSearchInput = '';
      _rc.cart = angular.copy(_rc.cart_template);
      _rc.variables = angular.copy(_rc.variables_template);
      storage.set('mrd-web-access', _rc.access);
      storage.set('mrd-web-cart', _rc.cart);
      storage.set('mrd-web-variables', _rc.variables);
    };

    _rc.newOrderSoft = function () { // Retain customer information...
      var savedCustomerDetails = angular.copy(_rc.cart.customer);
      // And clean up ready for injection...
      delete savedCustomerDetails.address.geo_location;
      delete savedCustomerDetails.address.location_id;
      delete savedCustomerDetails.street_number;
      delete savedCustomerDetails.email;
      delete savedCustomerDetails.first_name;
      delete savedCustomerDetails.last_name;
      delete savedCustomerDetails.gender;
      delete savedCustomerDetails.phone_1;

      _rc.cart = angular.copy(_rc.cart_template);
      _rc.cart.customer = savedCustomerDetails;
      _rc.variables.restaurant = {};
      storage.set('mrd-web-access', _rc.access);
      storage.set('mrd-web-cart', _rc.cart);
      storage.set('mrd-web-variables', _rc.variables);
    };

    _rc.showMenu = function () {
      angular.element(document.getElementById('html')).addClass('show-menu');
    };

    _rc.hideWebV2ts = storage.get('mrd-web-hideWebV2');
    _rc.showWebV2 = _rc.hideWebV2ts ? Date.now() > _rc.hideWebV2ts + (1000 * 60 * 60 * 8) : true;

    _rc.hideMRDbanner = function () {
      storage.set('mrd-web-hideWebV2', Date.now());
      _rc.showWebV2 = false;
    };

    if (!_rc.showWebV2) {
      _rc.hideMRDbanner();
    }


    _rc.hideMenu = function () {
      angular.element(document.getElementById('html')).removeClass('show-menu');
    };

    _rc.closePopup = function (campaign_slug) {
      _rc.popups[campaign_slug] = true;
      var expireDate = new Date();
      expireDate.setDate(expireDate.getDate() + 1);
      $cookies.putObject('mrd-web-popups', _rc.popups, {'expires': expireDate});
    };

    _rc.vote = function (email) {
      return new Promise(function(resolve,reject){
        _rc.voteForm.date = new Date().toISOString().slice(0, 10);
        _rc.voteForm.source = 'WEB_APP';
        // _rc.voteForm.type = 'area-not-serviced';
        if (email) _rc.voteForm.email = email;
        _rc.isWorking = true;
        voteAreaFactory.save(_rc.voteForm,
          function () {

            _rc.voteForm = {};
            if (_rc.voteformname) _rc.voteformname.$setPristine();
            _rc.isWorking = false;
            _rc.isSuccess = true;
            resolve();
          },
          function () {
            _rc.isWorking = false;
            reject();
          }
        );
      });
    };


    _rc.newsletterForm = {};
    _rc.newsletterForm.email = '';
    _rc.newsletterMessage = '';
    _rc.isWorkingNewsletter = false;
    _rc.newsletterSuccess = false;
    _rc.newsletterFailure = false;

    _rc.newsletterSubmit = function () {
      _rc.isWorkingNewsletter = true;
      $http.jsonp('http://mrd.us8.list-manage.com/subscribe/post-json?u=c043277d2d0ad5e8841f7c8b9&amp;id=4960d20747&EMAIL=' + _rc.newsletterForm.email + '&c=JSON_CALLBACK')
        .then(function () { // (data)
          // _rc.newsletterMessage = data.data.msg;
          _rc.newsletterMessage = 'To complete the subscription process, please click the link in the email we just sent you.';
          _rc.isWorkingNewsletter = false;
          _rc.newsletterSuccess = true;
          _rc.newsletterFailure = false;
        }, function (data) {
          _rc.newsletterMessage = data.data.msg;
          _rc.isWorkingNewsletter = false;
          _rc.newsletterSuccess = false;
          _rc.newsletterFailure = true;
        });
    };

    /* Autocomplete */

    _rc.key_event = null;
    _rc.suggest_list = null;
    _rc.suggest_list_index = -1;
    _rc.addresses_list_index = -1;
    _rc.autocompleteSearchFocus = false;
    _rc.autocompleteSearchInput = '';
    _rc.placeSearch = null;
    _rc.geolocation = false;
    _rc.autocomplete = null;

    _rc.confirm_location_action = false;
    _rc.confirm_location_loading = false;
    _rc.confirm_location_result = false;

    _rc.place = null;
    _rc.address = 'init';

    _rc.autocompleteSearchFocusBlurDelay = function () {
      $timeout(function () {
        _rc.autocompleteSearchFocus = false;
        _rc.addresses_list_index = -1;
        _rc.suggest_list_index = -1;
      }, 200);
    };


    _rc.initAutocomplete = function () {
      // Create the autocomplete object, restricting the search to geographical
      // location types.
      _rc.autocompleteSessionToken = new google.maps.places.AutocompleteSessionToken();
      _rc.autocompleteService = new google.maps.places.AutocompleteService();
      _rc.s = new google.maps.places.PlacesService(document.createElement('div')); // Why the div?

      // When the user selects an address from the dropdown, populate the address
      // fields in the form.

    };

    _rc.initAutocomplete();

    _rc.autocompleteFillInAddress = function ($event, saved_address, suggestion, type) {
      //console.log('click',saved_address)
      //console.log($event,saved_address,suggestion);

      if (type === 'confirm') {
        _rc.confirm_location_action = true;
        _rc.confirm_location_loading = true;
        $rootScope.$broadcast('loading:show');
      }

      var placeID = null;
      if (suggestion && suggestion.place_id) {
        placeID = suggestion.place_id;
      } else if (saved_address && saved_address.place_id) {
        placeID = saved_address.place_id;
      } else if (this.dataset && this.dataset.place_id) {
        placeID = this.dataset.place_id;
      } else {
        return;
      }

      _rc.s.getDetails({
          fields: ['address_components', 'formatted_address', 'geometry', 'place_id'],
          placeId: placeID,
          sessionToken: _rc.autocompleteSessionToken
        },
        function (place) {
          // Second Argument 'status'

          if (place === null) { // Address or Street Name
            _rc.search_popup = true;
            _rc.search_popup_message = 'Please enter a <strong>Street Address</strong>!';
            $scope.$apply();
            return;
          }
          _rc.functionThatTakesPlace(place, type);

        });

    };

    _rc.functionThatTakesPlace = function (place, type) {

      if (typeof place === 'string') {
        return;
      }

      var lat = place.geometry.location.lat();
      var lng = place.geometry.location.lng();

      // Save Lat/Long to Cart Customer Address
      $scope._rc.variables.hasLocation = true;
      $scope._rc.variables.address = {}; // Reset Address

      $scope._rc.variables.address.latitude = lat.toFixed(5).toString();
      $scope._rc.variables.address.longitude = lng.toFixed(5).toString();

      $scope._rc.cart.customer.address.latitude = lat.toFixed(5).toString();
      $scope._rc.cart.customer.address.longitude = lng.toFixed(5).toString();

      // Get each component of the address from the place details
      // and fill the corresponding field on the form.
      $scope._rc.processAndStoreAddress(place);

      var saved_addresses_len = $scope._rc.addresses.length;

      var check = false;
      if (saved_addresses_len === 0) {
        $scope._rc.addresses.push(angular.copy($scope._rc.variables.address));
        check = true;
      } else {
        for (var j = 0; j < saved_addresses_len; j++) {
          if ($scope._rc.addresses[j].latitude === $scope._rc.variables.address.latitude &&
            $scope._rc.addresses[j].longitude === $scope._rc.variables.address.longitude) {
            check = true;
          } else {
            /* @todo Add Event Tracking */
          }
        }
      }
      if (!check) {
        if ($scope._rc.addresses.length > 4) {
          $scope._rc.addresses.splice(0, 1);
        }
        $scope._rc.addresses.push(angular.copy($scope._rc.variables.address));
      }

      // $scope._rc.addresses.push(angular.copy($scope._rc.variables.address));
      storage.set('mrd-web-addresses', $scope._rc.addresses);
      storage.set('mrd-web-variables', $scope._rc.variables);

      $scope._rc.cart.customer.address = angular.copy($scope._rc.variables.address);
      delete $scope._rc.cart.customer.address.street_number; // Remove street number for now...

      /* Analytics */
      $scope._rc.trackSearchSuccess($state.current.name);
      //Save Address
      $rootScope.$broadcast('cart:modified');
      storage.set('mrd-web-cart', $scope._rc.cart);


      // If it's a confirm address address search type
      if (type === 'confirm') {
        console.log('type === \'confirm\' commented out');
        // var restList = restaurantFactory.lookup({
        //   latitude: _rc.variables.address.latitude,
        //   longitude: $scope._rc.variables.address.longitude,
        //   street_name: $scope._rc.variables.address.street_name
        // });
        //
        // restList.$promise.then(function (list) {
        //
        //   // console.log(list)
        //   var found = false;
        //   if(list.items && list.items.length > 0){
        //     angular.forEach(list.items, function(item){
        //       // console.log(item.id +'==='+$scope._rc.cart.restaurant.id);
        //       if(item.id === $scope._rc.cart.restaurant.id){
        //         found = true;
        //       }
        //     });
        //   }
        //
        //   if(found){
        //     _rc.confirm_location_loading = false;
        //     _rc.confirm_location_result = 'yes';
        //     $rootScope.$broadcast('loading:hide');
        //   } else {
        //     _rc.confirm_location_loading = false;
        //     _rc.confirm_location_result = 'no';
        //     $rootScope.$broadcast('loading:hide');
        //   }
        //
        // });

      } else {

        _rc.confirm_location_action = false;
        _rc.confirm_location_loading = false;
        _rc.confirm_location_result = false;

        $state.go('location', {
          lat: $scope._rc.variables.address.latitude,
          lng: $scope._rc.variables.address.longitude,
          street_name: $scope._rc.variables.address.street_name
        });
      }
    };

    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    _rc.autocompleteGeolocate = function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          _rc.geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          //console.log(_rc.geolocation)

          // var circle = new google.maps.Circle({
          //   center: geolocation,
          //   radius: position.coords.accuracy
          // });
          // _rc.s.setBounds(circle.getBounds());
        });
      }
    };

    _rc.autocompleteSearch = function () {

      _rc.searchIsWorking = true;
      _rc.suggestions = []; // Empty it
      if (_rc.autocompleteSearchInput) {
        _rc.search_popup = false;
        _rc.search_popup_message = '';
        var predictionObject = {
          input: _rc.autocompleteSearchInput,
          types: ['address'],
          componentRestrictions: {
            country: 'za'
          },
          sessionToken: _rc.autocompleteSessionToken
        };
        if (_rc.geolocation) {
          //location : new google.maps.LatLng('-33.917665','18.428281'), // Cape Town
          //location : new google.maps.LatLng('-26.206312','28.030416'),//Joburg
          predictionObject.location = new google.maps.LatLng(_rc.geolocation);
          predictionObject.radius = 50000;
        }
        _rc.autocompleteService.getPlacePredictions(predictionObject, _rc.displaySuggestions);
      } else {
        _rc.searchIsWorking = false;
        _rc.search_popup = true;
        _rc.search_popup_message = 'Please enter an address...';
      }
    };


    _rc.displaySuggestions = function (predictions, status) {
      _rc.search_popup = false;
      _rc.search_popup_message = '';
      _rc.searchIsWorking = false;
      if (status !== google.maps.places.PlacesServiceStatus.OK) {
        _rc.search_popup = true;
        _rc.search_popup_message = 'Mmm... can\'t find that address.';
        $scope.$apply();
        return;
      }

      _rc.suggestions = predictions;
      $scope.$apply();

    };

    _rc.autocompleteKeyEvent = function (event) {

      _rc.key_event = event;


      if (_rc.key_event.keyCode === 13 && (_rc.suggestions.length > 0 || _rc.addresses.length > 0)) { // Enter
        if (_rc.suggest_list_index === -1) {
          _rc.suggest_list_index = 0;
        }
        if (_rc.addresses_list_index === -1) {
          _rc.addresses_list_index = 0;
        }

        if (!_rc.autocompleteSearchFocus) {
          if (_rc.autocompleteSearchInput === '') { // Saved
            var sa = _rc.addresses[_rc.addresses_list_index];
            if (sa) $location.url('/order/restaurants/'+sa.latitude+'/'+sa.longitude+'/'+sa.street_name.replace(' ','+'));
          } else { // Suggests
            _rc.autocompleteFillInAddress(event, null, _rc.suggestions[_rc.suggest_list_index], null);
          }
        }
      }
      if (_rc.key_event.keyCode === 40 && (_rc.suggestions.length > 0 || _rc.addresses.length > 0)) { // Down

        if (!_rc.autocompleteSearchFocus || _rc.autocompleteSearchInput !== '') { // Saved
          _rc.suggest_list_index += 1;
          if (_rc.suggest_list_index === _rc.suggestions.length) {
            _rc.suggest_list_index = 0;
          }
        }
        if (!_rc.autocompleteSearchFocus || _rc.autocompleteSearchInput === '') { // Suggested
          _rc.addresses_list_index += 1;
          if (_rc.addresses_list_index === _rc.addresses.length) {
            _rc.addresses_list_index = 0;
          }
        }
      }
      if (_rc.key_event.keyCode === 38 && (_rc.suggestions.length > 0 || _rc.addresses.length > 0)) { // Up

        if (!_rc.autocompleteSearchFocus || _rc.autocompleteSearchInput !== '') { // Saved
          _rc.suggest_list_index -= 1;
          if (_rc.suggest_list_index < 0) {
            _rc.suggest_list_index = _rc.suggestions.length - 1;
          }
        }
        if (!_rc.autocompleteSearchFocus || _rc.autocompleteSearchInput === '') { // Suggested
          _rc.addresses_list_index -= 1;
          if (_rc.addresses_list_index < 0) {
            _rc.addresses_list_index = _rc.addresses.length - 1;
          }
        }

      }

    };

    _rc.findFood = function () {
      document.getElementById('autocomplete').focus();
      _rc.search_popup = true;
      _rc.search_popup_message = 'Start by entering an address...';
    };

    _rc.goToSavedAddress = function (saved_address) {

      _rc.clearCart();
      _rc.cart.customer.address = angular.copy(saved_address);
      _rc.variables.address = angular.copy(saved_address);
      storage.set('mrd-web-cart', _rc.cart);
      storage.set('mrd-web-variables', _rc.variables);
      $state.go('location', {
        lat: saved_address.latitude,
        lng: saved_address.longitude,
        street_name: saved_address.street_name
      });

    };

    _rc.find_me_clear = function () {};

    _rc.findingOnMapClose = function () {};

    _rc.autocompleteClearAddress = function () {
      _rc.autocompleteSearchInput = '';
      _rc.search_popup = false;
      _rc.search_popup_message = '';
      _rc.suggest_list_index = -1;
      _rc.addresses_list_index = -1;
    };

    /* Global Direction Buttons */
    _rc.menuBack = function () {
      $state.go('location', {
        lng: _rc.variables.address.longitude,
        lat: _rc.variables.address.latitude,
        street_name: $scope._rc.variables.address.street_name
      });
    };

    _rc.convertSlugUgly = function (status_slug) {

      if (status_slug) {
        return status_slug.replace(/_/g, ' ');
      }
    };


    _rc.checkMissingPrice = function (option_extra_addon_item) {
      if (option_extra_addon_item.price) {
        return;
      } else {
        option_extra_addon_item.price = 0;
        return;
      }
    };

    _rc.processAndStoreAddress = function (place) {

      var componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        sublocality_level_2: 'long_name',
        sublocality_level_1: 'long_name',
        sublocality: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'long_name',
        postal_code: 'short_name'
      };
      _rc.variables.address.place_id = place.place_id;
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
          var val = place.address_components[i][componentForm[addressType]];

          //console.log(addressType, val);
          //Special - save to extra veriables
          if (addressType === 'street_number') {
            _rc.variables.address.street_number = val;
          }
          if (addressType === 'route') {
            _rc.variables.address.street_name = val;
          }
          if (addressType === 'sublocality_level_2') {
            _rc.variables.address.suburb = val;
          }
          if (addressType === 'locality') {
            _rc.variables.address.city = val;
          }
          if (addressType === 'administrative_area_level_1') {
            _rc.variables.address.province = val;
          }
          if (addressType === 'postal_code') {
            _rc.variables.address.postal_code = val;
          }
        }
      }
    };

    _rc.convertSlugUglyForUser = function (status_slug) {

      if (status_slug) {
        switch (status_slug) {
          case 'awaiting_feedback':
            return 'Awaiting Feedback';

          case 'restaurant_accepted':
            return 'Accepted';

          case 'restaurant_rejected':
            return 'Rejected';

          case 'system_auto_rejected':
          case 'restaurant_auto_rejected':
            return 'No Response';

          case 'delivered':
            return 'Delivered';

          case 'cancelled':
            return 'Cancelled';

          case 'failed_delivery_injection':
          case 'failed_restaurant_injection':
            return 'Failed';

          case 'delivery_instruction_received':
          case 'en_route':
          case 'en_route_to_collection':
            return 'Restaurant Prepping Food';

          case 'en_route_to_delivery':
            return 'Food Collected';

          case 'nearby':
            return 'Mr D driver is close';

          case 'doorbell':
            return 'Mr D driver has arrived';

          case 'at_restaurant':
            return 'Restaurant Prepping Food';

          default:
            return status_slug;
        }

        //return status_slug.replace('_', ' ').replace('_', ' ').replace('_', ' ').replace('_', ' ').replace('_', ' ');
      }
    };

    _rc.convertDeliverability = function (input) {
      if (input === 'collect_and_delivery') {
        return 'Collections and Deliveries';
      }
      if (input === 'collect') {
        return 'Collections Only';
      }
      if (input === 'delivery') {
        return 'Deliveries Only';
      }

    };

    _rc.buildAddress = function (address) {

      if (!address) {
        return;
      } // Load Time Fix

      var inAddress = address;
      var outAddress = [];

      if (inAddress.street_number && inAddress.street_name) {
        outAddress.push(inAddress.street_number + ' ' + inAddress.street_name);
      } else if (inAddress.street_name) {
        outAddress.push(inAddress.street_name);
      }

      if (inAddress.suburb) {
        outAddress.push(inAddress.suburb);
      } else if (inAddress.city) {
        outAddress.push(inAddress.city);
      } else if (inAddress.province) {
        outAddress.push(inAddress.province);
      }

      if (inAddress.postal_code) {
        outAddress.push(inAddress.postal_code);
      }

      return outAddress.join(', ');
    };

    _rc.buildFullAddress = function (address) {
      var inAddress = address;
      var outAddress = [];

      if (inAddress.street_number && inAddress.street_name) {
        outAddress.push(inAddress.street_number + ' ' + inAddress.street_name);
      } else if (inAddress.street_name) {
        outAddress.push(inAddress.street_name);
      }
      if (inAddress.suburb) {
        outAddress.push(inAddress.suburb);
      }
      if (inAddress.city) {
        outAddress.push(inAddress.city);
      }
      if (inAddress.province) {
        outAddress.push(inAddress.province);
      }
      if (inAddress.postal_code) {
        outAddress.push(inAddress.postal_code);
      }

      return outAddress.join(', ');
    };

    _rc.buildSuburb = function (address) {

      var inAddress = address;
      var outAddress = [];

      if (inAddress.suburb) {
        outAddress.push(inAddress.suburb);
      } else {
        outAddress.push(inAddress.city);
      }

      return outAddress.join(', ');
    };

    _rc.buildStreet = function (address) {
      var inAddress = address;
      var outAddress = [];

      if (inAddress.street_number && inAddress.street_name) {
        outAddress.push(inAddress.street_number + ' ' + inAddress.street_name);
      }
      // Null?
      if (outAddress.length === 0) {
        outAddress.push(inAddress.street_name);
      }

      return outAddress.join(', ');
    };

    _rc.buildStreetProvince = function (address) {
      var inAddress = address;
      var outAddress = [];

      outAddress.push(_rc.buildStreet(address));

      if (inAddress.province) {
        outAddress.push(inAddress.province);
      }

      return outAddress.join(', ');
    };

    _rc.buildStreetProvincePostal = function (address) {
      var inAddress = address;
      var outAddress = [];

      outAddress.push(_rc.buildStreet(address));

      if (inAddress.province) {
        outAddress.push(inAddress.province);
      }

      if (inAddress.postal_code) {
        outAddress.push(inAddress.postal_code);
      }

      return outAddress.join(', ');
    };

    /* Track Outbound Link */
    _rc.trackOutboundLink = function (category, position, url) {
      if (position === 'footer') {
        position = 'footer-' + _rc.state.current.name;
      }
      ga('send', 'event', 'Outbound Link - ' + category, category, position + ' | ' + url, {
        'transport': 'beacon',
        'hitCallback': function () {
          document.location = url;
        }
      });
    };

    _rc.track = function (cat, act) {
      //ga('send', 'event', [eventCategory], [eventAction], [eventLabel], [eventValue], [fieldsObject])
      ga('send', 'event', cat, act);
    };

    /* Register */
    _rc.trackRegisterSuccess = function () {
      ga('send', 'event', 'sign_up_page', 'sign_up');
      fbq('track', 'CompleteRegistration');
    };
    _rc.trackRegisterFailure = function () {
      ga('send', 'event', 'Register Failure', 'Register', 'Callback Failed');
    };

    /* Login */
    _rc.trackLoginSuccess = function () {
      ga('send', 'event', 'log_in_page', 'log_in');
    };
    _rc.trackLoginFailure = function (response) {
      var message = 'Unset';
      if (response && response.error && response.error.friendly_message) {
        message = response.error.friendly_message;
      } else if (response && response.data.error && response.data.error.friendly_message) {
        message = response.data.error.friendly_message;
      } else {
        message = 'Message Missing';
      }

      ga('send', 'event', 'Login Failure', 'Login', 'Callback | ' + message);
    };

    /* Search */
    _rc.trackSearchSuccess = function (current_state_name) {

      var state = 'generic';
      if (current_state_name) {
        state = current_state_name;
      }
      ga('send', 'event', 'Search Success', 'Search', state);
      fbq('track', 'Search');
    };

    /* Restaurants Load */
    $rootScope.trackRestaurantsLoadSuccess = function () {
      ga('send', 'event', 'Restaurants Load Success', 'Restaurants', 'Callback Success');
    };
    $rootScope.trackRestaurantsLoadFailure = function () {
      ga('send', 'event', 'Restaurants Load Failure', 'Restaurants', 'Callback Failed');
    };
    _rc.trackRestaurantsAreaNotServiced = function () {
      ga('send', 'event', 'Restaurants Not Serviced', 'Restaurants', 'Area not serviced');
    };

    /* Checkout */
    _rc.trackCheckoutSuccess = function () {
      ga('send', 'event', 'Checkout Success', 'Checkout', 'Callback Success');
      fbq('track', 'InitiateCheckout');
    };
    _rc.trackCheckoutFailure = function (message) {
      if (message) {
        ga('send', 'event', 'Checkout Failure', 'Checkout', 'Callback Failed - ' + message);
      } else {
        ga('send', 'event', 'Checkout Failure', 'Checkout', 'Callback Failed');
      }
      fbq('track', 'InitiateCheckout');
    };

    /* Order Status */
    _rc.trackOrderRestaurantAccepted = function () {
      ga('send', 'event', 'Restaurant Accepted', 'Order', 'Order Restaurant Accepted');
    };
    _rc.trackexceptionOrder = function (status) {
      ga('send', 'event', 'Order Exception', 'Order', 'Order Failure - ' + status);
    };

    /* Order History Navigate */
    _rc.trackNavigateOrderHistory = function () {
      ga('send', 'event', 'Navigate to Order History', 'Navigate', 'Navigate to Order History');
    };

    /* Capacity Delay */
    _rc.trackCapacityDelaySurfaced = function () {
      ga('send', 'event', 'Capacity Delay Popup', 'Popup', 'Capacity Delay Popup');
    };

    _rc.trackOrderEcommerce = function () {
      /* Analytics Ecommerce */
      var analytics_order = {
        'id': _rc.cart.id,                         // Transaction ID. Required. (google,facebook)
        'order_id': _rc.cart.id,                  //(twitter)
        'invoice_number': _rc.cart.invoice_number,
        'transaction_id': _rc.cart.invoice_number, // (snapchat)
        'affiliation': _rc.cart.restaurant.name + ' ' + (_rc.cart.restaurant.address? _rc.cart.restaurant.address.suburb : ''),   // Affiliation or store name.
        'revenue': _rc.cart.totals.total,         // Grand Total. (google)
        'value': _rc.cart.totals.total,           // Grand Total. (facebook,twitter)
        'revenue_value': _rc.cart.totals.total,   //Grand Total. (bing)
        'price': _rc.cart.totals.total,           //Grand Total. (snapchat)
        'shipping': _rc.cart.totals.delivery_fee,   // Shipping.
        'tip': _rc.cart.totals.driver_tip,
        'currency': 'ZAR',
        //'coupon': null, //assigned below
        'group_id': _rc.cart.restaurant.restaurant_group_id,
        'restaurant_id': _rc.cart.restaurant.id,
        'restaurant_name': _rc.cart.restaurant.name + ' ' + (_rc.cart.restaurant.address? _rc.cart.restaurant.address.suburb : ''),
        //'quantity': null, //the cart is unfortunately cleared of items (will require development) (google)
        //'total_item_quantity': null, //(facebook)
        'num_items': 1, //(twitter)
        'customer_id': _rc.cart.customer.id,
        'first_purchase': (_rc.cart.statistics? !_rc.cart.statistics.sum_no_of_orders : false),
        'products': []
        //'tax': 0                     // Tax.
      };
      if (_rc.cart.discounts && _rc.cart.discounts.coupon && _rc.cart.discounts.coupon.code) {
        analytics_order.coupon = _rc.cart.discounts.coupon.code;
        analytics_order.coupon_value = _rc.cart.discounts.coupon.code;
      }

      if (_rc.cart.items && _rc.cart.items.length > 0) {
        for (var i = 0; i < $scope._rc.cart.items.length; i++) {
          var analytics_order_item = {
            'name': _rc.cart.items[i].description,     // Name or ID is required.
            'id': _rc.cart.items[i].variant_id,                          // Product SKU
            'price': _rc.cart.items[i].price,
            'variant': _rc.cart.items[i].variant_name,                      // Enhanced Ecommerce only
            'quantity': _rc.cart.items[i].quantity
          };
          analytics_order.products.push(analytics_order_item);
        }
      }
      $analytics.transactionTrack(analytics_order);
      window._log_purchase(analytics_order); //see `index.html`
    };

    /* Generic */
    _rc.trackGenericEvent = function (category, message) {
      ga('send', 'event', 'Generic', category, message);
    };


    _rc.subtotal_calc = function (item) {
      var items = [];
      if (item) {
        //_rc.itemPrice(item);
        items = [item];
      } else {
        items = $scope._rc.cart.items;
      }

      var local_sub_total = 0;
      var local_sub_total_old_diff = 0;

      if (typeof items === 'undefined') {
        return false;
      }

      for (var i = 0; i < items.length; i++) {
        var currentItem = items[i];
        var additionalCost = 0;

        var basePrice = parseFloat(currentItem.price);
        if (currentItem.old_price) {
          local_sub_total_old_diff += (parseFloat(currentItem.old_price) - basePrice) * currentItem.quantity;
        }

        //Options
        if (currentItem.options) {
          for (var o = 0; o < currentItem.options.length; o++) {
            var currentOption = currentItem.options[o];
            if (currentOption.price) {
              additionalCost += parseFloat(currentOption.price); //should all be zero
            }
          }
        }
        //Extras
        if (currentItem.extras) {
          for (var e = 0; e < currentItem.extras.length; e++) {
            var currentExtra = currentItem.extras[e];
            if (currentExtra.price) {
              additionalCost += parseFloat(currentExtra.price);
            }
          }
        }
        //Addons
        if (currentItem.addonGroups && currentItem.addonGroups.length) {
          for (var iAddonGroup = 0; iAddonGroup < currentItem.addonGroups.length; iAddonGroup++) {
            var addonGroup = currentItem.addonGroups[iAddonGroup];

            if (addonGroup.items && addonGroup.items.length) {
              basePrice += window.getAddonGroupSubTotal(addonGroup.items.mop('price'), addonGroup.price_modifier, currentItem.price);

              additionalCost += addonGroup.items.reduce(function(total,item){
                if (item.extras && item.extras.length) total+= item.extras.reduce(function(extrasTotal,option){return extrasTotal + option.price;},0);
                if (item.options && item.options.length) total+= item.options.reduce(function(optionsTotal,option){return optionsTotal + option.price;},0);
                return total;
              },0);
            }
          }
        }

        additionalCost *= currentItem.quantity;

        var increments = currentItem.quantityPay + currentItem.quantityFree;
        var payFactor = currentItem.quantityPay / increments;
        var quantityDiscount = Math.floor(currentItem.quantity / increments) * increments;
        var quantityFullPrice = currentItem.quantity % increments;
        additionalCost += quantityDiscount * basePrice * payFactor;
        additionalCost += quantityFullPrice * basePrice;

        local_sub_total = local_sub_total + additionalCost;
      }


      if (item) {
        return local_sub_total;

      } else {
        _rc.cart.totals.subtotal_old_diff = local_sub_total_old_diff;
        _rc.cart.totals.local_subtotal = local_sub_total;
      }

    };


    _rc.total_calc_no_return = function () {

      _rc.subtotal_calc();
      var discount = 0;
      var deliveryFee = _rc.cart.totals.delivery_fee;
      var deliveryFeeTypeStandard = true;
      // var serviceFee = _rc.cart.totals.delivery_fee;
      var additionalFee = 0;
      var subtotal = _rc.cart.totals.local_subtotal;

      var active_promotion = $scope._rc.variables.restaurant.active_promotion;
      var additional_fees = $scope._rc.variables.restaurant.additional_fees;

      if (active_promotion !== undefined) {
        if (!active_promotion.cart_message) {

          if (active_promotion.type === 'FREE_DELIVERY' && _rc.cart.type === 'delivery') {
            //service_fee  = 0; implicit in that it never changes for this condition
            deliveryFeeTypeStandard = false;
          } else if (active_promotion.type === 'DISCOUNTED_DELIVERY' && _rc.cart.type === 'delivery') {
            deliveryFee = active_promotion.delivery_fee;
            // deliveryFee = 0;
            deliveryFeeTypeStandard = false;

          } else if (active_promotion.type === 'CONDITIONAL_FREE_DELIVERY' && _rc.cart.type === 'delivery') {
            deliveryFeeTypeStandard = false;

            if (subtotal >= active_promotion.min_spend) {
              deliveryFee = 0;
            } else {
              deliveryFee = $scope._rc.variables.restaurant.delivery_fee;
            }

          } else if (active_promotion.type === 'FOOD_PERCENTAGE_OFF') {
            discount = ((active_promotion.percentage) / 100) * subtotal;

          } else if (active_promotion.type === 'CONDITIONAL_FOOD_PERCENTAGE_OFF') {
            if (subtotal >= active_promotion.min_spend) {
              discount = ((active_promotion.percentage) / 100) * _rc.cart.totals.local_subtotal;
            }
          } else if (active_promotion.type === 'FOOD_AMOUNT_OFF') {
            discount = active_promotion.amount;

          } else if (active_promotion.type === 'CONDITIONAL_FOOD_AMOUNT_OFF') {
            if (subtotal >= active_promotion.min_spend) {
              discount = active_promotion.amount;
            }
          }
        } else {
          // IF cart_message exitst then the discount is determined by the server and
          // will be set on the response of checkout
        }
      }


      _rc.cart.delivery_standard = deliveryFeeTypeStandard;

      if (_rc.cart.type === 'collect') {
        //_rc.cart.totals.subtotal = (_rc.cart.totals.subtotal) - discount;
        deliveryFee = 0;
      }


      if (additional_fees !== undefined) {
        if (additional_fees[0].additional_fee_type === 'mrd_additional_fee_amount') {
          additionalFee = additional_fees[0].fee;
          _rc.cart.totals.premium_fee = additionalFee;   // might be overkill
        }
      }


      _rc.cart.totals.food_discount = -discount;
      var total = subtotal + additionalFee + deliveryFee  - discount;

      _rc.cart.totals.delivery_fee = deliveryFee;
      _rc.cart.totals.local_total = total;
    };


    function timeSince(date) {

      var seconds = Math.floor((new Date() - date) / 1000);

      var interval = Math.floor(seconds / 31536000);

      if (interval > 1) {
        return interval + ' years';
      }
      interval = Math.floor(seconds / 2592000);
      if (interval > 1) {
        return interval + ' months';
      }
      interval = Math.floor(seconds / 86400);
      if (interval > 1) {
        return interval + ' days';
      }
      interval = Math.floor(seconds / 3600);
      if (interval > 1) {
        return interval + ' hours';
      }
      interval = Math.floor(seconds / 60);
      if (interval > 1) {
        return interval + ' minutes';
      }
      return Math.floor(seconds) + ' seconds';
    }

    _rc.timeAgo = function (date) {
      if (date) {
        date = date.replace(' ', 'T');
        date = new Date(Date.parse(date));
        date.setHours(date.getHours() - 2); // ?? hack
        return timeSince(date);
      } else {
        return '';
      }
    };


    _rc.checkForUndefined = function (input, desired_value) {
      if (typeof input === 'undefined') {
        return desired_value;
      } else {
        return input;
      }
    };

    _rc.slugify = function (input) {
      return input
        .toLowerCase()
        .replace(/[^\w ]+/g, '')
        .replace(/ +/g, '-');
    };

    _rc.convertTimeUgly = function (date) {
      if (date === 'upcoming') {
        return '...';
      }
      if (date) {
        var moment_date_object = moment(date);
        return '' + moment_date_object.format('h:mm') + '<span>' + moment_date_object.format('a') + '</span>';
      } else {
        return '';
      }
    };

    _rc.timeNice = function (date) {
      if (date) {
        var moment_date_object = moment(date);
        return '' + moment_date_object.format('D MMM YYYY');
      } else {
        return '';
      }
    };

    $scope.$on('cart:modified', function (event, input) {
      $scope._rc.cart.fresh = false;
      if (!input) {
        input = 'default';
      }
    });

    $rootScope.$on('seo_update', function (event, args) {

      if (args.overwrite && args.overwrite.title_tag) {
        $scope._rc.title_tag = args.overwrite.title_tag;
      } else {
        $scope._rc.title_tag = SEO.titleTag(args.state.name);
      }

      if (args.overwrite && args.overwrite.description_tag) {
        $scope._rc.description_tag = args.overwrite.description_tag;
      } else {
        $scope._rc.description_tag = SEO.descriptionTag(args.state.name);
      }
      document.querySelector('meta[name="description"]').setAttribute('content', $scope._rc.description_tag);

      if (args.overwrite && args.overwrite.keywords_tag) {
        $scope._rc.keywords_tag = args.overwrite.keywords_tag;
      } else {
        $scope._rc.keywords_tag = SEO.keywordsTag(args.state.name);
      }
      document.querySelector('meta[name="keywords"]').setAttribute('content', $scope._rc.keywords_tag);

    });

    _rc.imageResize = function (source, size) {
      if (!size) {
        size = '540';
      }
      if (source) {
        return source.replace('restaurants/', 'resized/' + size + '/restaurants/');
      } else {
        return '';
      }
    };
    _rc.getThumborSource = function(base_url, filename, size){
      var imageUrl = base_url+'/'+size + filename;
      //console.log(imageUrl);
      return imageUrl;
    };


    _rc.prefix_replace = function (input) {
      if (input) {
        return input.replace('**PP** ', '');
      }
    };


    _rc.ZeroButTrue = function (input) {

      if (input === 0) {
        return true;
      }
      return false;
    };

    //#########################################################
    //  Wallet modal
    //#########################################################
    _rc.walletShow = false;
    _rc.showWallet = function(e){
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      _rc.walletShow = true;
    };

    _rc.walletClose = function() {
      _rc.walletShow = false;
    };

    //#########################################################
    //  CARD MANAGEMENT
    //#########################################################

    _rc.cardsShow = false;
    _rc.cardsLoading = false;
    _rc.cardsEditingText = 'edit';

    _rc.showCards = function(e, provider) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      _rc.showPayuCardForm = false;
      _rc.cardsShow = true;
      _rc.cardsLoading = true;
      _rc.loadCards(provider).then(function(cards){
        _rc.cards = cards;
        _rc.cardsLoading = false;
      })
      .catch(function(er){
        _rc.cardsError = er.message || er.data.error.friendly_message || er;
        _rc.cardsLoading = false;
      });
    };

    _rc.cardsEdit = function(){
      if (_rc.cardEditing) {
        _rc.cardEditing = false;
        _rc.cardsEditingText = 'edit';
      } else {
        _rc.cardEditing = true;
        _rc.cardsEditingText = 'done';
      }
    };

    _rc.cardEdit = function(card) {
      console.log('card edit', card);

      $http.put(window.env.apiURL + 'v3/users/' + _rc.access.user.id + '/saved_cards/' + card._uuid, {
        label: card.update_nickname,
        is_default: card.update_is_default
      }).then(function (result) {
          _rc.cardsEdit();
          _rc.cardsLoading = true;
          _rc.loadCards('all').then(function (cards) {
            _rc.cards = cards;
            _rc.cardsLoading = false;
          });
        })
        .catch(function (er) {
          console.warn('Unable to update card', card.n);
        });

      // const fetched = await fetch(`${env.caApiURL}restaurant/secure_fields_form_submit`, {
      //   method: 'PUT',
      //   body: JSON.stringify({
      //     response: JSON.parse(result), // already JSON string
      //     saved_card: {
      //       label: document.getElementById('card-nickname').value,
      //       is_default: document.getElementById('is-default').checked,
      //     }
      //   }),
      //   headers: [
      //     ['Content-Type', 'application/json'],
      //     ['Authorization', `${auth}`],
      //   ]
      // });

      // if (fetched.status === 200) {
      //   console.log('Card added');
      // } else if (fetched.status === 422) {
      //   const body = await fetched.json();
      //   console.warn(body);
      //   alert('Validation error received. Please check the console.');
      // } else {
      //   const body = await fetched.json();
      //   console.warn(body);
      //   alert(`POST /restaurant/secure_fields_form_submit error. Please check the console.`);
      // }
    };

    _rc.cardDelete = function(e,card) {
      e.preventDefault();
      e.stopPropagation();
      if (card.isDeleting) return;
      card.isDeleting = true;
      $http.delete(window.env.apiURL + 'v3/users/'+_rc.access.user.id+'/saved_cards/'+card._uuid, {bypassErrorHandler:true})
      .then(function(result){
        card.isDeleted = true; //css delete animation
      })
      .catch(function(er){
        console.warn('Unable to delete card', card.n);
        card.isDeleting = false;
      });
		};

		// _rc.cardEdit = function(e,card) {
    //   e.preventDefault();
		// 	e.stopPropagation();

		// 	$http.put(window.env.apiURL + 'v3/users/' + _rc.access.user.id + '/saved_cards/' + card._uuid, {
		// 		bypassErrorHandler: true,
		// 		body: JSON.stringify()
		// 	})
    //   .then(function(result){
    //     card.isDeleted = true; //css delete animation
    //   })
    //   .catch(function(er){
    //     console.warn('Unable to delete card', card.n);
    //     card.isDeleting = false;
    //   });
		// };

    _rc.cardsClose = function() {
      _rc.cardsShow = false;
      _rc.cards = null;
      _rc.cardEditing = false;
      _rc.cardsEditingText = 'edit';
    };

    _rc.loadCards = function (prov, showFormIfNoCards) {

      const stafftesting = !window.config.hide_payu_add_card_profile || storage.get('mrd-web-payu');
      const cartProvider = _rc.cart.payment.provider;

      const provider = stafftesting || cartProvider ? '?provider=' + prov : ''; // should omit provider on profile with no stafftesting


      return $http.get(window.env.apiURL + 'v3/users/'+_rc.access.user.id+'/saved_cards' + provider, {bypassErrorHandler:true})
      .then(function(res){

        if (showFormIfNoCards && !res.data.items.length) _rc.showPayuCardForm = true; // only from checkout

        return res.data.items
        .sort(function(a,b){
          if (a.is_expired !== b.is_expired) return a.is_expired?1:-1;
          var card_expiry_a = +(a.card_expiry.substring(2)+a.card_expiry.substring(0,2));
          var card_expiry_b = +(b.card_expiry.substring(2)+b.card_expiry.substring(0,2));
          return card_expiry_a - card_expiry_b;
        })
        .map(function(card){
          var n = card.card_number;
          return Object.assign(card,{
            n: n.substring(n.length-6),
            type: card.card_scheme.toLowerCase()
          });
        });
      });
		};



    //#########################################################
    //  Payu
    //#########################################################

    // set local storage using
    if ($location.search().stafftesting) storage.set('mrd-web-payu', $location.search().stafftesting);

    window.addEventListener('remote-config-loaded', function () {
      _rc.payuEnabled = !window.config.hide_payu_card_add || storage.get('mrd-web-payu');
    });
		_rc.showPayuCardForm = false;

		_rc.maskCardNickname = function (index) {
			_rc.cards[index].update_nickname = _rc.cards[index].update_nickname.replace(/[!@#$%&*()+={[}\]:;<,>\?\/"]/, '');
		};

    //#########################################################
    //  SEO
    //#########################################################

    $rootScope.seo_manifest = {};


    _rc.hubs_master = [];

    _rc.cities = [];

    _rc.cuisine_types = [];


    _rc.groups = [];
    // Just Names for Hubs

    _rc.hubs = [];
    for (var i = 0; i < _rc.hubs_master.length; i++) {
      _rc.hubs.push(_rc.hubs_master[i].name);
    }

  });
